import { render, staticRenderFns } from "./OldLogo.vue?vue&type=template&id=1deef6a9&"
import script from "./OldLogo.vue?vue&type=script&lang=js&"
export * from "./OldLogo.vue?vue&type=script&lang=js&"
import style0 from "./OldLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports